import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { dlnCatchResponse } from '@delen/extensions';
import { EMPTY, throwError } from 'rxjs';
import { AppRoute } from 'src/app/app.route';
import { LoginRoute } from 'src/app/features/login/login.route';
import { redirectToVerification } from './authentication-redirect.helper';
import { AuthenticationStore } from './authentication.store';

/**
 * Handles 410 Gone errors when user access has been revoked.
 * Only redirects from confirmation page to verification page (to trigger isExpired logic).
 * Does NOT redirect on verification page (lets the page handle the error to set isExpired state).
 */
export const revokedAccessInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const activatedRoute = inject(ActivatedRoute);
  const authStore = inject(AuthenticationStore);

  return next(req).pipe(
    dlnCatchResponse((err) => {
      if (!(err instanceof HttpErrorResponse) || err.status !== HttpStatusCode.Gone) {
        return throwError(() => err);
      }

      const isOnConfirmation = router.url.includes(`/${AppRoute.Login}/${LoginRoute.Confirmation}`);

      if (isOnConfirmation) {
        redirectToVerification(router, activatedRoute, authStore);
        return EMPTY;
      }

      return throwError(() => err);
    }),
  );
};
